import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/link.js");
